import { monitorValue } from "../../util/monitorUtils";

const buildEmergencyMatrixData = (monitor) => {

    const matrix = {};

    for (let car = 1; car <= 8; car++) {

        const start = ((car - 1) * 4) + 1;

        const alavancas = [];
        const alavancaCategory = {};

        // Somente alavanca 1 e 2 de cada carro
        const alavancasMonitoradas = [
            start,
            start + 1
        ];

        alavancasMonitoradas.forEach((current, index) => {

            const key = `alavanca${current}`;

            if (
                monitorValue(
                    monitor,
                    key,
                    0
                ) !== 0
            ) {
                alavancas.push(index);

                alavancaCategory[index] =
                    monitor?.[key]?.category;
            }
        });

        matrix[car] = {

            alavanca: alavancas,

            alavancaCategory,

            botaoSoco:
                monitorValue(
                    monitor,
                    `acionadoCarro${car}`,
                    0
                ) !== 0,

            botaoSocoCategory:
                monitor?.[
                    `acionadoCarro${car}`
                ]?.category
        };
    }

    return matrix;
};

export default buildEmergencyMatrixData;